import { Charge } from "@/pages/sy/models/Charge";
import { useUpsertChargeMutation } from "@/pages/sy/hooks/queries/useChargeMutations";

type UseCommentsHandlersProps = {
  currentOperatorId: number | null;
  charge: Charge | null;
  setCommentInput: (keyboardInput: string) => void;
  setKeyboardVisible: (keyboardVisible: boolean) => void;
  setIsCommentModalOpen: (isCommentModalOpen: boolean) => void;
  setError: (error: string) => void;
  setNotificationMessage: (message: string) => void;
};

export const useCommentsHandlers = ({
  currentOperatorId,
  charge,
  setCommentInput,
  setKeyboardVisible,
  setIsCommentModalOpen,
  setError,
  setNotificationMessage,
}: UseCommentsHandlersProps) => {
  const upsertChargeMutation = useUpsertChargeMutation();

  const handleSaveComments = (comments: string) => {
    if (!charge?.ChargeId) return;

    const chargeToUpdate: Charge = {
      ...charge,
      Comments: comments,
      OperatorId: currentOperatorId,
    };

    upsertChargeMutation.mutate(chargeToUpdate, {
      onSuccess: () => {
        setNotificationMessage("Comments updated successfully");
      },
      onError: (error) => {
        setError(
          "Error updating comments: " +
            (error instanceof Error ? error.message : String(error)),
        );
      },
    });
  };

  const handleOpenCommentModal = () => {
    const currentComments = charge?.Comments || "";
    setCommentInput(currentComments);
    setKeyboardVisible(true);
    setIsCommentModalOpen(true);
  };

  const handleCloseCommentModal = () => {
    setIsCommentModalOpen(false);
    setKeyboardVisible(false);
  };

  return {
    handleSaveComments,
    handleOpenCommentModal,
    handleCloseCommentModal,
    isCommentMutating: upsertChargeMutation.isPending,
  };
};
